import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import UnderscoreDivider from './UnderscoreDivider';
import { Paragraph, Header4 } from './Typography';
import { ssColorCyan, ssColorBlack } from '../constants/style-constants';
import { vunit, hunit } from '../lib/style-helpers';

const IconCardCSS = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  text-align: center;
  background-color: ${ssColorCyan};
  padding: ${vunit(3)} 0 ${vunit(6)};

  /*
    Unfortunately dynamically created component targetting doesn't seem
    to work here. So the svg element selector is used instead as a workaround.
  */
  > svg,
  ${Header4},
  ${Paragraph},
  ${UnderscoreDivider} {
    margin: ${vunit(3)} ${hunit(3)} 0;
    color: ${ssColorBlack};
  }

  ${UnderscoreDivider} {
    background-color: ${ssColorBlack};
  }
`;

const IconCard = ({
  Icon,
  title,
  body,
}) => (
  <div css={IconCardCSS}>
    <Icon color={ssColorBlack} />
    <Header4>{title}</Header4>
    <UnderscoreDivider />
    <Paragraph>{body}</Paragraph>
  </div>
);

IconCard.propTypes = {
  Icon: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default IconCard;
